import { useEffect, useState } from 'react';
import { getDefaultSiteContent, getPublicSiteContent } from 'lib/siteContentCms';
import { usePublishedHero } from './usePublishedHero';

const immediateHeroKeys = new Set(['servicesHero', 'webinarsHero']);
const loadedPublicContent = new Map();

function getLoadingSiteContent(key) {
  const fallback = getDefaultSiteContent(key);
  const cached = loadedPublicContent.get(key);
  const immediateHero = immediateHeroKeys.has(key);
  return {
    ...fallback,
    eyebrow: '',
    title: '',
    body: '',
    primaryCtaLabel: '',
    primaryCtaPath: '',
    secondaryCtaLabel: '',
    secondaryCtaPath: '',
    tertiaryCtaLabel: '',
    tertiaryCtaPath: '',
    // Services waits for published copy on a cold visit; warm visits retain the cached actions too.
    ...(immediateHero && key !== 'servicesHero' ? {
      eyebrow: fallback.eyebrow,
      title: fallback.title,
      body: fallback.body,
    } : {}),
    ...cached,
    imageUrl: '',
    imageAlt: '',
    __loading: true,
    __source: 'loading',
    __fallbackReason: '',
  };
}

export function useSiteContent(key) {
  const heroSlot = key.endsWith('Hero') ? (key === 'contactHero' ? 'homeHero' : key) : null;
  const media = usePublishedHero(heroSlot);
  const [content, setContent] = useState(() => getLoadingSiteContent(key));

  useEffect(() => {
    let mounted = true;
    setContent(getLoadingSiteContent(key));

    getPublicSiteContent(key).then((loadedContent) => {
      if (mounted) {
        if (immediateHeroKeys.has(key)) loadedPublicContent.set(key, loadedContent);
        setContent({ ...loadedContent, __loading: false });
      }
    });

    return () => {
      mounted = false;
    };
  }, [key]);

  return heroSlot ? { ...content, imageUrl: media.imageUrl, imageAlt: media.imageAlt, __media: media } : content;
}
